export default async function handleDownloadFile(
    url: string,
    fileName = 'unknown',
) {
    if (!url) return;

    const res = await fetch(url);
    if (!res.ok) throw new Error('Falha no download');
    const blob = await res.blob();
    const file = new File([blob], fileName, {
        type: blob.type,
    });
    const blobUrl = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
}
